
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M16.68 30.195a7.414 7.414 0 0 1-1.58-3.104L4.623 29.789c.323 1.434.839 2.84 1.559 4.189A16.684 16.684 0 0 0 8.53 37.32l8.15-7.125ZM29.799 23.834a8.65 8.65 0 0 0-1.015-3.61l9.371-5.297a19.414 19.414 0 0 1 1.782 4.46c.38 1.451.586 2.907.63 4.345l-10.768.102ZM29.288 32.181a7.826 7.826 0 0 1-3.16 1.467l2.05 10.056a17.574 17.574 0 0 0 4.231-1.428 17.595 17.595 0 0 0 3.44-2.195l-6.56-7.9ZM21.455 14.073a8.446 8.446 0 0 0-3.259 1.855l-7.518-8.042a18.973 18.973 0 0 1 3.894-2.815 18.99 18.99 0 0 1 4.07-1.647l2.813 10.65Z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-stroke",attrs:{"d":"m9.416 35.186 8.689-7.02m12.34-9.573 8.036-7.023M5.632 26.5l10.533-1.941m15.824-2.384 10.82-2.145M12.2 8.59l7.02 8.689m9.617 12.248 6.978 8.128M20.884 4.806l2.173 10.713m2.254 15.844 2.044 10.62m13.964-26.538c4.424 9.515.296 20.815-9.219 25.239-9.515 4.423-20.815.296-25.239-9.22-4.424-9.515-.296-20.815 9.22-25.239 9.515-4.423 20.814-.296 25.238 9.22Zm-9.975 4.637a8 8 0 1 1-14.508 6.745 8 8 0 0 1 14.509-6.745Z","stroke":"#234652"}})])
          )
        }
      }
    